import React, { Component } from 'react'
import '../styles/GlobalStyle.css'
import { db, firebase } from '../firebase/Firebase'
import { flattenDoc, linkAfterLogin } from '../Util'
import ColType from '../Types'
import { message, Input, Button, Icon, Modal } from 'antd'
import CustomFooter from './CustomFooter'
import DemoSignIn from './DemoSignIn'

const errorMessage = (description) => {
    message.error(description)
}

class DemoSignInModal extends Component {
    state = {
        visible: false,
        role: 'admin',
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    render() {
        const roles = {
            'admin': 'Admin',
            'coach': 'Coach',
            'teacher': 'Teacher',
            'student': 'Student'
        };
        return (
            <div>
                {Object.keys(roles).map((role) => {
                    const roleTitle = roles[role];
                    return <div className="ant-menu-item p-0 border-bottom-lighter"
                        onClick={() => {
                            if (this.props.dropdownVisibleChange) {
                                this.props.dropdownVisibleChange(false);
                            }

                            this.setState({
                                visible: true,
                                role: role,
                            })
                        }}>
                        <span className="font-16 p-2 block font-bold flex flex-v-center w-100">
                            <span className="va-minus-1 font-20">{roleTitle}</span>
                            <Icon type="right" className='ml-auto' />
                        </span>
                    </div>
                })}

                <Modal title="Sign in"
                    visible={this.state.visible}
                    footer={null}
                    width={520}
                    onCancel={() => {
                        this.setState({
                            visible: false,
                        })
                    }}>
                    <div className='pb-2'>
                        <DemoSignIn
                            role={this.state.role}
                        />
                    </div>
                </Modal>
            </div>

        )
    }
}

export default DemoSignInModal